var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.16667V2.5M6.25 4.16667V2.5M2.70833 6.66667H17.2917M2.5 8.37C2.5 6.6075 2.5 5.72583 2.86333 5.0525C3.19169 4.45178 3.70153 3.97023 4.32 3.67667C5.03333 3.33333 5.96667 3.33333 7.83333 3.33333H12.1667C14.0333 3.33333 14.9667 3.33333 15.68 3.67667C16.3075 3.97833 16.8167 4.46 17.1367 5.05167C17.5 5.72667 17.5 6.60833 17.5 8.37083V12.4642C17.5 14.2267 17.5 15.1083 17.1367 15.7817C16.8083 16.3824 16.2985 16.8639 15.68 17.1575C14.9667 17.5 14.0333 17.5 12.1667 17.5H7.83333C5.96667 17.5 5.03333 17.5 4.32 17.1567C3.70166 16.8633 3.19183 16.3821 2.86333 15.7817C2.5 15.1067 2.5 14.225 2.5 12.4625V8.37Z",
    stroke: "#8D91AC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.76843bbe2d835f15bda7a525e9efc120.svg";
export { ForwardRef as ReactComponent };